module.exports = __webpack_public_path__ + "img/ipad-en-2.b83b7bd.jpg";